import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showLoginModal } from "src/actions/ui/login_actions";
import UnauthenticatedMessage from "./unauthenticated_message";
import { RootState } from "src/reducers/root_reducer";

interface PrivateRouteProps {
  children: React.ReactNode;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(
    (state: RootState) => state.session.isLoggedIn
  );

  useEffect(() => {
    if (!isLoggedIn) {
      dispatch(showLoginModal(true, { fixed: true }));
    }
  }, [isLoggedIn, dispatch]);

  if (!isLoggedIn) {
    return (
      <div className="flex justify-center pt-8 text-xs text-red-500">
        <UnauthenticatedMessage />
      </div>
    );
  }

  return <>{children}</>;
};

export default PrivateRoute;
